<template>
  <v-row justify="center">
    <v-dialog
      :value="dialog"
      max-width="500"
      persistent
      @input="closeConfirmModal"
    >
      <v-card>
        <DialogCardTitle
          :title="title"
          @close="closeConfirmModal"
        />

        <v-card-text class="px-6 pb-4">
          <p
            class="accent--text"
            v-html="message"
          ></p>
        </v-card-text>

        <v-card-actions class="px-6 pt-0 d-flex justify-end confirm-card-actions">
          <v-btn
            color="primary"
            class="px-4 d-flex align-center simple-button"
            plain
            :ripple="false"
            @click="closeConfirmModal"
          >
            <span class="pl-1 btn-text">Отмена</span>
          </v-btn>

          <v-btn
            color="primary"
            class="px-4 d-flex align-center"
            :loading="loading"
            @click="confirm"
          >
            <v-icon
              class="uikit-icon white size-18"
              style="margin-bottom: 1px"
              :class="icon"
            />
            <span class="pl-2 btn-text">
              {{ btnText }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogCardTitle from '../ui/DialogCardTitle'

export default {
  components: { DialogCardTitle },

  props: {
    title: {
      type: String,
      default: 'Удаление'
    },
    btnText: {
      type: String,
      default: 'Удалить'
    },
    dialog: Boolean,
    message: String,
    icon: {
      type: String,
      default: 'trash'
    },
    loading: Boolean
  },

  methods: {
    confirm() {
      this.$emit('confirm')
    },

    closeConfirmModal() {
      this.$emit('closeConfirmModal')
    }
  }
}
</script>

<style scoped>
.v-card__actions.confirm-card-actions {
  box-shadow: 0px 0px 11px 0px #0000000d;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
</style>
